import Axois from '../utils/axios'
import EventEmitter from "../../utils/eventEmitter";



export const loadLotSerialNumbers = async () => {
  let response = await Axois.get('/lotSerialNumbers').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadLotSerialNumber = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/lotSerialNumbers');
        const responseData = await requests.data;
        return {...responseData, lotSerialNumber: {}};
        // return { positions: [], budgets: [], analytic: {}};
      
      default:
        let response = await Axois.get('/lotSerialNumbers/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}



const useLotSerialNumberAPI = () => {
  
  const create = async (data, success) => {
    try {
      const response = await Axois.post('/lotSerialNumbers', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('lotSerialNumbers_created', data.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/lotSerialNumbers/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('lotSerialNumbers_updated', data.number);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, update };
}


export default useLotSerialNumberAPI;